export const selectMenuGroupedByCategory = (state) => (
  state.restaurant.menu.reduce((acc, el) => {
    if (!acc[el.category]) {
      acc[el.category] = [];
    }
    acc[el.category].push(el);
    return acc;
  }, {})
);